export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "ManageMatch",
  alternateName: "Manage Match",
  url: "https://managematch.services",
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "ManageMatch",
  alternateName: "Manage Match",
  url: "https://managematch.services",
  logo: "https://managematch.services/favicon.png",
  description:
    "ManageMatch (Manage Match) koordiniert und organisiert professionelle Dienstleistungen für Privat- und Gewerbekunden in Hanau und Umgebung.",
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+49-155-65412425",
    contactType: "customer service",
    availableLanguage: "German",
  },
  sameAs: [],
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "ManageMatch",
  alternateName: "Manage Match",
  description:
    "ManageMatch (Manage Match) koordiniert und organisiert professionelle Dienstleistungen für Privat- und Gewerbekunden in Hanau und Umgebung. Hausmeisterservice, Reinigung, Elektro, Gartenpflege, Security und mehr – alles aus einer Hand.",
  url: "https://managematch.services",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Marienstr. 18",
    addressLocality: "Hanau",
    postalCode: "63457",
    addressCountry: "DE",
  },
  email: "support@managematch.services",
  areaServed: {
    "@type": "GeoCircle",
    geoMidpoint: {
      "@type": "GeoCoordinates",
      latitude: 50.1267,
      longitude: 8.9169,
    },
    geoRadius: "50000",
  },
  serviceType: [
    "Hausmeisterservice",
    "Reinigungsservice",
    "Elektrotechnik",
    "Gartenarbeiten",
    "Winterdienst",
    "Security Service",
    "Car Detailing",
    "IT Helpdesk",
  ],
  priceRange: "€€",
};

export const serviceSchemas = [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Hausmeisterservice in Hanau",
    description:
      "ManageMatch organisiert professionelle Hausmeister für Ihre Immobilie – Wartung, Instandhaltung, Notdienst und Gebäudemanagement für Privat- und Gewerbekunden in Hanau.",
    provider: { "@type": "LocalBusiness", name: "ManageMatch" },
    areaServed: "Hanau und Umgebung",
    serviceType: "Hausmeisterservice",
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Reinigungsservice in Hanau",
    description:
      "ManageMatch koordiniert professionelle Reinigungskräfte für Büros, Praxen, Treppenhäuser und Privatwohnungen – gründlich, zuverlässig und termingerecht.",
    provider: { "@type": "LocalBusiness", name: "ManageMatch" },
    areaServed: "Hanau und Umgebung",
    serviceType: "Reinigungsservice",
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Elektrotechnik in Hanau",
    description:
      "ManageMatch organisiert qualifizierte Elektriker für Installationen, Reparaturen, Smart Home und Sicherheitstechnik – für Privat und Gewerbe.",
    provider: { "@type": "LocalBusiness", name: "ManageMatch" },
    areaServed: "Hanau und Umgebung",
    serviceType: "Elektrotechnik",
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Gartenarbeiten in Hanau",
    description:
      "ManageMatch koordiniert erfahrene Gärtner für Rasenpflege, Heckenschnitt, Bepflanzung und Grünanlagenpflege in Hanau und Umgebung.",
    provider: { "@type": "LocalBusiness", name: "ManageMatch" },
    areaServed: "Hanau und Umgebung",
    serviceType: "Gartenarbeiten",
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Winterdienst in Hanau",
    description:
      "ManageMatch organisiert zuverlässigen Winterdienst – Schneeräumung, Streudienst und 24/7 Bereitschaft für sichere Wege und Zufahrten.",
    provider: { "@type": "LocalBusiness", name: "ManageMatch" },
    areaServed: "Hanau und Umgebung",
    serviceType: "Winterdienst",
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Security Service in Hanau",
    description:
      "ManageMatch organisiert professionelle Sicherheitsdienste für Veranstaltungen, Objektschutz und Personenschutz in Hanau und Rhein-Main.",
    provider: { "@type": "LocalBusiness", name: "ManageMatch" },
    areaServed: "Hanau und Umgebung",
    serviceType: "Security Service",
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Car Detailing in Hanau",
    description:
      "ManageMatch koordiniert professionelle Fahrzeugaufbereitung – Außenreinigung, Innenraumpflege, Lackversiegelung und Flottenservice.",
    provider: { "@type": "LocalBusiness", name: "ManageMatch" },
    areaServed: "Hanau und Umgebung",
    serviceType: "Car Detailing",
  },
  {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "IT Helpdesk in Hanau",
    description:
      "ManageMatch koordiniert kompetente IT-Unterstützung – PC-Einrichtung, Netzwerk, Server-Wartung und IT-Sicherheit für Privat und Gewerbe.",
    provider: { "@type": "LocalBusiness", name: "ManageMatch" },
    areaServed: "Hanau und Umgebung",
    serviceType: "IT Helpdesk",
  },
];

export const homepageFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Was genau macht ManageMatch?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "ManageMatch koordiniert und organisiert professionelle Dienstleistungen für Privat- und Gewerbekunden. Wir sind Ihr zentraler Ansprechpartner und stellen qualifizierte Fachkräfte für Hausmeisterservice, Reinigung, Elektro, Gartenpflege, Winterdienst, Security, Car Detailing und IT Helpdesk bereit.",
      },
    },
    {
      "@type": "Question",
      name: "Wer führt die Arbeiten durch?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Die Arbeiten werden von sorgfältig ausgewählten und geprüften Fachkräften und Partnerunternehmen durchgeführt, die wir für Sie koordinieren. ManageMatch fungiert als Ihr zentraler Ansprechpartner.",
      },
    },
    {
      "@type": "Question",
      name: "Welche Dienstleistungen organisiert ManageMatch?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "ManageMatch deckt acht Kernbereiche ab: Hausmeisterservice, Elektrotechnik, Car Detailing, IT Helpdesk, Gartenarbeiten, Security Service, Winterdienst und Reinigungsservice – jeweils für Privat- und Gewerbekunden.",
      },
    },
    {
      "@type": "Question",
      name: "In welchen Regionen ist ManageMatch tätig?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "ManageMatch ist hauptsächlich in Hanau und der Rhein-Main-Region aktiv. Für genaue Informationen zu unserem Einzugsgebiet kontaktieren Sie uns bitte direkt.",
      },
    },
    {
      "@type": "Question",
      name: "Wie wird die Qualität der Dienstleistungen sichergestellt?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Alle unsere Partner werden sorgfältig ausgewählt und regelmäßig überprüft. Wir holen nach jedem Auftrag Feedback ein, um die Qualität kontinuierlich zu verbessern und erstklassige Ergebnisse zu garantieren.",
      },
    },
    {
      "@type": "Question",
      name: "Wie schnell kann ManageMatch einen Dienstleister organisieren?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Je nach Dienstleistung und Verfügbarkeit können wir oft innerhalb von 24–48 Stunden einen qualifizierten Fachmann organisieren. Bei dringenden Notfällen versuchen wir, noch schneller zu reagieren.",
      },
    },
    {
      "@type": "Question",
      name: "Sind die beauftragten Dienstleister versichert?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ja, alle unsere Partnerunternehmen und Fachkräfte verfügen über die notwendigen Versicherungen für ihre jeweiligen Tätigkeitsbereiche.",
      },
    },
    {
      "@type": "Question",
      name: "Kann ich den Umfang der Dienstleistungen individuell anpassen?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Selbstverständlich! Wir erstellen nach einer Bedarfsanalyse ein maßgeschneidertes Leistungspaket, das genau auf Ihre Anforderungen zugeschnitten ist – egal ob Privat oder Gewerbe.",
      },
    },
    {
      "@type": "Question",
      name: "Bietet ManageMatch auch regelmäßige Dienstleistungen an?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ja, wir organisieren sowohl einmalige als auch regelmäßige Dienstleistungen. Für wiederkehrende Aufträge können wir individuelle Vereinbarungen mit zuverlässigen Partnern für Sie treffen.",
      },
    },
    {
      "@type": "Question",
      name: "Was kostet der Service von ManageMatch?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Wir erstellen transparente Angebote ohne versteckte Kosten. Die Anfrage und Beratung ist kostenfrei und unverbindlich – kontaktieren Sie uns einfach für ein individuelles Angebot.",
      },
    },
  ],
};

export const dienstleistungenFaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Welche Hausmeister-Aufgaben übernimmt ManageMatch?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "ManageMatch organisiert Hausmeister für regelmäßige Objektbegehungen, Kleinreparaturen, Müllentsorgung, Überwachung von Handwerkern, Schlüsselverwaltung sowie Gebäudemanagement, technische Betriebsführung und Notdienst für Gewerbekunden.",
      },
    },
    {
      "@type": "Question",
      name: "Kann ManageMatch auch Reinigungskräfte für Büros und Treppenhäuser organisieren?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ja, ManageMatch koordiniert professionelle Reinigungskräfte für Wohnungs-, Büro-, Praxis- und Treppenhausreinigung, sowie Grundreinigung, Fensterreinigung und tägliche Unterhaltsreinigung.",
      },
    },
    {
      "@type": "Question",
      name: "Bietet ManageMatch auch Winterdienst an?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Ja, wir organisieren zuverlässige Winterdienst-Partner für Gehweg- und Einfahrtsräumung, Streudienst, Großflächenräumung und 24/7 Bereitschaftsdienst – für Privat und Gewerbe.",
      },
    },
    {
      "@type": "Question",
      name: "Wie kann ich ein Angebot bei ManageMatch anfragen?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Einfach unser Kontaktformular ausfüllen, uns eine E-Mail senden oder anrufen. Wir melden uns zeitnah bei Ihnen mit einem kostenlosen und unverbindlichen Angebot.",
      },
    },
  ],
};
